import { Expose } from 'class-transformer';

import { SnBaseLayer } from './base-layer';
import { SnLayerType } from './layer-type';

export class SnEsriStreamLayer extends SnBaseLayer {
  @Expose()
  public streamDefinitionUrl: string;

  public readonly type = SnLayerType.EsriStream;
}
